import { render, staticRenderFns } from "./SecureMeetingsPage.vue?vue&type=template&id=2a4be70f"
import script from "./SecureMeetingsPage.vue?vue&type=script&lang=js"
export * from "./SecureMeetingsPage.vue?vue&type=script&lang=js"
import style0 from "./SecureMeetingsPage.vue?vue&type=style&index=0&id=2a4be70f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports